import axios from "axios";
import { PROCESS_AUTOMATION_SERVICE_URL } from "../Common/Constant/API";
import { commonRequestHeaders } from "../Common/request/headers";

const getHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
    "vf-trace-transaction-id": crypto.randomUUID(),
    ...commonRequestHeaders(),
  };
};

export const fetchRepositories = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/azure/repositories`,
      {
        headers: {
          ...getHeaders(),
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching repositories:", error);
    throw error;
  }
};

export const fetchOpenedReleaseHotfixes = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/azure/repositories/search`,
      {
        branchPatterns: ["release/*", "hotfix/*"],
      },
      {
        headers: {
          ...getHeaders(),
          "Content-Type": "application/json"
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching opened release/hotfixes:", error);
    throw error;
  }
};
